const CLIENT = "GraphQL Client";
const MIN_RETRIES = 0;
const MAX_RETRIES = 3;
const GQL_API_ERROR = "An error occurred while fetching from the API. Review 'graphQLErrors' for details.";
const UNEXPECTED_CONTENT_TYPE_ERROR = "Response returned unexpected Content-Type:";
const NO_DATA_OR_ERRORS_ERROR = "An unknown error has occurred. The API did not return a data object or any errors in its response.";
const CONTENT_TYPES = {
    json: "application/json",
    multipart: "multipart/mixed",
};
const RETRY_WAIT_TIME = 1000;
const RETRIABLE_STATUS_CODES = [429, 503];

export { CLIENT, CONTENT_TYPES, GQL_API_ERROR, MAX_RETRIES, MIN_RETRIES, NO_DATA_OR_ERRORS_ERROR, RETRIABLE_STATUS_CODES, RETRY_WAIT_TIME, UNEXPECTED_CONTENT_TYPE_ERROR };
//# sourceMappingURL=constants.mjs.map
